<template>
  <div class="plat-form-wrap">
    <div class="slides-wrap">
      <a-carousel arrows>
        <div
          class="dot-item"
          :style="{ backgroundImage: `url(${bgImg})` }"
        ></div>
      </a-carousel>
      <div class="imgText">
        <div class="btn technicalBtn" @click="toRouter('techDealInfos')">
          查看全部
        </div>
      </div>
    </div>
    <div class="body-wrap home-mini-width">
      <MarketDemand></MarketDemand>
    </div>
  </div>
</template>

<script>
import { Mixin } from './mixins'
import MarketDemand from '@/views/MPlatformPortal/components/MarketDemand'
export default {
  data() {
    return {
      bgImg: require('@/assets/images/zQImg/技术需求库banner.png')
    }
  },
  mixins: [Mixin],
  components: {
    MarketDemand
  },
  mounted() {
    let key = process.env.VUE_APP_KEY
    switch (key) {
      case 'Hy':
        this.bgImg = require('@/assets/images/HyImg/技术需求库banner.png')
        break
      case 'Mm':
        this.bgImg = require('@/assets/images/MmImg/技术需求库banner.png')
        break
      case 'Yj':
        this.bgImg = require('@/assets/images/YjImg/技术需求库banner.png')
        break
      case 'Mz':
        this.bgImg = require('@/assets/images/MzImg/技术需求库banner.png')
        break
      case 'SzTech':
        this.bgImg = require('@/assets/images/SzTech/技术需求库banner.png')
        break
    }
    this.init()
  },
  methods: {
    toRouter(router) {
      this.$router.push({
        name: router,
        params: { selectVal: JSON.stringify(this.selectVal) }
      })
    },
    // tab切换
    selectTab(val) {
      this.selectedIndx = val.index
      this.selectedTab = val.tab.name
      this.params.industrialType = val.tab.key
      this.selectVal = val.tab
      this.init()
    }
  }
}
</script>
